/**
 * Reglas para animar sin tener el WebView dibujando sin parar.
 *
 * ## El problema
 *
 * Dentro del APK, una animación que se repite para siempre obliga al WebView a
 * dibujar 60 frames por segundo mientras esté en pantalla, aunque nadie toque
 * nada. Medido en la Tab Active5 (2026-10-08) con el punto verde del
 * cronómetro: 60 fps y 154-194 % de un núcleo; quieto, 0 fps y 2 %. Animar algo
 * «barato» no lo arregla: latiendo por opacidad o por transform seguía en
 * 61 fps y ~120 %. Tras 6 h así con la pantalla encendida, el WebView se colgó
 * por dentro y Android enseñó «ROIS no responde».
 *
 * ## La solución
 *
 * Una animación que puede quedarse en pantalla sin límite se repite un número
 * finito de veces y se queda quieta en un estado que siga leyéndose bien.
 * `tests/unit/styles/infinite-animation-guard.spec.ts` impide volver a meter
 * un `infinite` fuera de su lista justificada.
 *
 * Además, si el usuario tiene activado «reducir movimiento» en el sistema, no
 * se anima nada:
 *
 * ```ts
 * import { reducedMotion } from '../../../styles/motion';
 *
 * export const Dot = styled.span`
 *   animation: ${pulse} 1.6s 3;
 *
 *   ${reducedMotion} {
 *     animation: none;
 *   }
 * `;
 * ```
 */
export const reducedMotion = '@media (prefers-reduced-motion: reduce)';
